import { PREMIUM_FEATURES } from "@common/flatRateBilling";
import { useOrgConnect } from "contexts/OrgConnect.context";
import { useAllowFeature } from "./useAllowFeature";

export function useCanConnectIntegrations(): boolean {
    const orgConnect = useOrgConnect();
    const { hasAccess, isFetched } = useAllowFeature(
        PREMIUM_FEATURES.INTEGRATIONS,
    );

    return Boolean(orgConnect) || !isFetched || hasAccess;
}
